import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from './dashboard.component';
import {HistoryComponent} from './history/history.component';
import {ConfigComponent} from './config/config.component';
import {AuthGuard} from '../router/auth-guard.service';

const routes: Routes = [
    {path: '',  component: DashboardComponent , canActivate: [AuthGuard], children :[
        {path: '',  component: ConfigComponent},
        {path: 'history', component: HistoryComponent}
    ]}
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]

})
export class MainRoutingModule {

}


// WEBPACK FOOTER //
// ./src/app/main/main-routing.module.ts